// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router'

import babelpolyfill from 'babel-polyfill'

// import './assets/base.css'
import './assets/desktop.css'
import './assets/fonts/iconfont.css'

import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

import '@geoman-io/leaflet-geoman-free';  
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';  

// import L from 'mapbox.js'
// // import 'mapbox.js/theme/style.css'



// // 引入 leaflet.draw
// import 'leaflet-draw/dist/leaflet.draw'
// import 'leaflet-draw/dist/leaflet.draw.css'

import 'vant/lib/index.css'

import { Card, Uploader, Form, Tabbar, TabbarItem, Calendar, NavBar, Col, Row, Button, RadioGroup, Radio, Icon, Tag, Divider, List, Cell, CellGroup, Tab, Tabs, Grid, GridItem, Picker, Field, Popup, Image as VanImage, PullRefresh, Toast, DropdownMenu, DropdownItem, Search } from 'vant'
// import 'vant/lib/index.css';

Vue.use(Uploader)
Vue.use(Form)
Vue.use(Card)

Vue.use(Tabbar)
Vue.use(TabbarItem)

Vue.use(Calendar)
Vue.use(NavBar)
Vue.use(Col)
Vue.use(Row)
Vue.use(Button)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Icon)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(List)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Picker)
Vue.use(Field)
Vue.use(Popup)
Vue.use(VanImage)
Vue.use(PullRefresh)
Vue.use(Toast)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Search)

Vue.config.productionTip = false

// // 加载控制台wykwykwyk*************************
// export const loadScript = (url, callback) => {
//   const script = document.createElement('script')
//   script.onload = () => callback()
//   script.src = url
//   document.body.appendChild(script)
// }

// loadScript(
//   'https://res.wx.qq.com/mmbizwap/zh_CN/htmledition/js/vconsole/3.0.0/vconsole.min.js',
//   () => {
//     // eslint-disable-next-line
//     new VConsole()
//   })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js